export enum ItemType {
  InstructorStudentDashboardv2 = 'instructorStudentDashboardv2',
  ResetAttempt = 'resetAttempts',
  CancelEditionAssessmentJob = 'cancelEditionAssessmentJobs',
  BulkAcceptGrade = 'bulkAcceptGrades',
  BulkVoids = 'bulkVoids',

  MathJob = 'mathJobs',

  LtiChangeLogs = 'ltiChangeLogs',
  Chat = 'chats',

  ChatMessage = 'chatMessages',
  ConnectionRequest = 'connectionRequests',
  BackfillLOsJob = 'backfillLOsJobs',

  ConnectionRequestSummary = 'connectionRequestSummaries',
  ReportJob = 'reportJobs',

  LtiTest = 'ltiTests',
  ConnectionUpdate = 'connectionUpdates',

  LtiTestEnrollments = 'ltiTestEnrollments',

  VideoQueueItem = 'videoQueueItems',

  VideoQueueJob = 'videoQueueJobs',

  CatalogPreview = 'catalogPreviews',
  ValidatePubEmail = 'validatePubEmails',

  PublisherPreview = 'publisherPreviews',

  DemoCourseJob = 'demoCourseJobs',
  BulkUpdateModules = 'bulkUpdateModules',

  BulkUpdateLearningObjectives = 'bulkUpdateLearningObjectives',

  BulkClearGradeSyncs = 'bulkClearGradeSyncs',

  SwapIsbns = 'swapIsbns',

  LearningObjective = 'learningObjectives',

  LearningObjectiveImport = 'learningObjectiveImports',
  LearningObjectiveExport = 'learningObjectiveExports',
  Like = 'likes',
  Signout = 'signouts',
  Thread = 'threads',
  MondayRow = 'mondayRows',
  LectureNote = 'lectureNotes',
  Summaries = 'summaries',
  AccessCode = 'accessCodes',

  BulkUpdateOnixRequests = 'bulkUpdateOnixRequests',
  AccessCodeOrder = 'accessCodeOrders',
  AccessCodeRefund = 'accessCodeRefunds',
  AdoptionEmail = 'adoptionEmails',
  AdoptionEmailTemplate = 'adoptionEmailTemplates',
  AccessCodePair = 'accessCodePairs',
  AIGenerateFlashcards = 'aiGenerateFlashcards',
  AIGenerateSlides = 'aiGenerateSlides',
  AIGenerateQuestions = 'aiGenerateQuestions',
  AIGeneratePrompts = 'aiGeneratePrompts',

  AccountingStatement = 'accountingStatements',
  DownloadAccessCodeOrder = 'downloadAccessCodeOrders',
  Adoption = 'adoptions',
  AdoptionLaunch = 'adoptionLaunches',
  AdoptionRequest = 'adoptionRequests',
  AdoptionCopy = 'adoptionCopies',
  AdoptionClone = 'adoptionClones',
  CopyAssignment = 'copyAssignments',

  AdoptionRequestJob = 'adoptionRequestJobs',
  Aggregate = 'aggregates',
  AIJob = 'aiJobs',
  AIQuestion = 'aiQuestions',
  AITranscriptSummary = 'aiTranscriptSummaries',
  AssignProductToCourseSection = 'assignProductToCourseSections',
  AssignProductToCourseSectionJob = 'assignProductToCourseSectionJobs',
  AIFlashcard = 'aiFlashcards',
  Answer = 'answers',
  Assignment = 'assignments',
  AssignmentSource = 'assignmentSources',
  BulkActivateSlides = 'bulkActivateSlides',
  BulkProvisionCourseSections = 'bulkProvisionCourseSections',
  AssignmentGroup = 'assignmentGroups',
  AssignmentResult = 'assignmentResults',
  AssignmentAttempt = 'assignmentAttempts',
  Attendance = 'attendances',
  Auth = 'auths',
  BillingMonthEnd = 'billingMonthEnds',
  BillingMonthEndRecipient = 'billingMonthEndRecipients',
  BillingPeriod = 'billingPeriods',
  BillingStatement = 'billingStatements',
  BulkActivateModules = 'bulkActivateModules',
  BulkActivateAssignments = 'bulkActivateAssignments',
  BulkActivateQuestions = 'bulkActivateQuestions',
  BulkExportQuestions = 'bulkExportQuestions',
  BulkUpdateTimesForAssignments = 'bulkUpdateTimesForAssignments',
  BulkUpdateNumberOfQuestionsForAssignments = 'bulkUpdateNumberOfQuestionsForAssignments',
  BulkUpdateQuestionBankForAssignments = 'bulkUpdateQuestionBankForAssignments',
  BulkAccessCode = 'bulkAccessCodes',
  InvoiceBulkAccessCodes = 'invoiceBulkAccessCodes',
  BulkCreateAssignment = 'bulkCreateAssignments',
  BulkCreateAssignmentSource = 'bulkCreateAssignmentSources',
  BulkChapterAssignment = 'bulkChapterAssignments',
  BulkDeactivatePublisherFees = 'bulkDeactivatePublisherFees',
  BulkAssignGrade = 'bulkAssignGrades',
  BulkRefunds = 'bulkRefunds',
  BulkUnenrollStudents = 'bulkUnenrollStudents',
  GcloudConnection = 'gcloudConnections',
  GcloudToken = 'gcloudTokens',
  GcloudRefreshToken = 'gcloudRefreshTokens',
  CanvasToken = 'canvasTokens',
  CanvasConnection = 'canvasConnections',
  CanvasRefreshToken = 'canvasRefreshTokens',
  CodeConfirmation = 'codeConfirmations',
  CampusID = 'campusIds',
  CourseSectionMerge = 'courseSectionMerges',

  CourseSectionPrice = 'courseSectionPrices',

  CourseSectionEnrollmentByMonthTotal = 'courseSectionEnrollmentByMonthTotals',
  QuickbooksToken = 'quickbooksTokens',
  QuickbooksConnection = 'quickbooksConnections',
  QuickbooksRefreshToken = 'quickbooksRefreshTokens',
  QuickbooksVendor = 'quickbooksVendors',
  QuickbooksCustomer = 'quickbooksCustomers',
  QuickbooksAllCustomer = 'quickbooksAllCustomers',
  QuickbooksAllVendor = 'quickbooksAllVendors',
  BulkActivatePublisherFees = 'bulkActivatePublisherFees',
  BulkExtraQuizAttempts = 'bulkExtraQuizAttempts',
  BulkExtraTestTime = 'bulkExtraTestTimes',
  BulkExtraQuizTime = 'bulkExtraQuizTimes',
  BulkProvisionTerms = 'bulkProvisionTerms',
  BulkExtendedDueDate = 'bulkExtendedDueDates',
  BulkMoveQuestions = 'bulkMoveQuestions',
  BulkUpdateSourcesForAssignment = 'bulkUpdateSourcesForAssignments',
  BulkOpt = 'bulkOpts',
  Syllabus = 'syllabus',
  BulkSyncGrades = 'bulkSyncGrades',
  CanvasAssignment = 'canvasAssignments',
  CanvasAssignmentGroup = 'canvasAssignmentGroups',
  CanvasModule = 'canvasModules',
  Charge = 'charges',
  CheckoutSession = 'checkoutSessions',
  ChapterContent = 'chapterContents',
  ChapterLabel = 'chapterLabels',
  Citation = 'citations',
  Courseware = 'coursewares',
  CoursewareIsbn = 'coursewareIsbns',
  CatalogRequest = 'catalogRequests',
  CatalogRequestCount = 'catalogRequestCounts',
  CourseCodeEnrollment = 'courseCodeEnrollments',
  CourseRequest = 'courseRequests',
  CourseRequestCount = 'courseRequestCounts',
  CoverImage = 'coverImages',
  Demo = 'demos',
  ResetDemo = 'resetDemos',
  DocumentConversionJob = 'documentConversionJobs',
  Book = 'books',
  FlashcardFeedback = 'flashcardFeedbacks',
  Bookmark = 'bookmarks',
  Company = 'companies',

  CompanyContact = 'companyContacts',
  Connection = 'connections',
  CreateChapter = 'createChapters',
  AddPagesToChapter = 'addPagesToChapters',
  RemoveChapter = 'removeChapters',
  InstructorInvite = 'instructorInvites',
  Issue = 'issues',
  LtiAssignment = 'ltiAssignments',
  Cost = 'costs',
  CostEstimate = 'costEstimates',
  Clone = 'clones',
  CourseCode = 'courseCodes',
  CourseSection = 'courseSections',
  DocumentAssessmentJob = 'documentAssessmentJobs',
  Edition = 'editions',
  EditionChargesAgg = 'editionChargesAggs',
  EditionConversionJob = 'editionConversionJobs',
  EditionAssessmentJob = 'editionAssessmentJobs',
  FinanceConnection = 'financeConnections',
  EmailConfirmation = 'emailConfirmations',
  Enrollment = 'enrollments',

  EnrollmentActivity = 'enrollmentActivities',

  EnrollmentChargesAggs = 'enrollmentChargesAggs',
  Grade = 'grades',
  GradeChangeRequest = 'gradeChangeRequests',
  /** @deprecated Use StudentChangeRequest — kept for backward compat while old endpoints still work */
  StudentChangeRequest = 'studentChangeRequests',
  StudentRequestConfig = 'studentRequestConfigs',
  GradeRecycle = 'gradeRecycles',
  EditionClone = 'editionClones',
  Flashcard = 'flashcards',
  FlashcardImport = 'flashcardImports',
  FlashcardExport = 'flashcardExports',
  FlashcardDeck = 'flashcardDecks',
  FlashcardMatchingGame = 'flashcardMatchingGames',
  GradeExport = 'gradeExports',

  GradeExportJob = 'gradeExportJobs',
  Identifier = 'identifiers',
  ImageAccessibilityJob = 'imageAccessibilityJobs',
  Impersonation = 'impersonations',
  ImportEnrollmentsJob = 'importEnrollmentsJobs',
  Invoice = 'invoices',
  InstructorStudentDashboard = 'instructorStudentDashboards',
  InvoiceAggregate = 'invoiceAggregates',
  Job = 'jobs',
  LtiJob = 'ltiJobs',
  LtiJobSchedule = 'ltiJobSchedules',
  JobSchedule = 'jobSchedules',
  Launch = 'launches',
  Message = 'messages',
  Module = 'modules',
  Note = 'notes',
  OnixJob = 'onixJobs',
  Person = 'people',
  BookOutline = 'bookOutlines',
  BookUpload = 'bookUploads',
  BookImageUpload = 'bookImageUploads',

  FullglassCoverImage = 'fullglassCoverImages',
  OnixRequest = 'onixRequests',
  PageContent = 'pageContents',
  PageLabel = 'pageLabels',
  Payment = 'payments',
  PhysicalAddress = 'physicalAddresses',
  Poll = 'polls',
  PollQuestion = 'pollQuestions',
  Price = 'prices',
  Print = 'prints',
  PrintPreview = 'printPreviews',
  Product = 'products',
  PromptPreview = 'promptPreviews',
  PublisherFee = 'publisherFees',
  PublisherProrate = 'publisherProrates',
  Question = 'questions',
  QuestionCount = 'questionCounts',
  QuestionAssignmentGrade = 'questionAssignmentGrades',
  QuestionCourseSectionGrade = 'questionCourseSectionGrades',
  QuestionFlag = 'questionFlags',
  QuestionImport = 'questionImports',
  QuestionExport = 'questionExports',
  QuestionFlagAggregate = 'questionFlagAggregates',
  QuestionUpload = 'questionUploads',
  Quiz = 'quizzes',
  ReaderProgress = 'readerProgresses',

  ReorderPages = 'reorderPages',

  RunAccountingStatements = 'runAccountingStatements',
  RollbackAccountingStatements = 'rollbackAccountingStatements',
  Schedules = 'schedules',
  QRCode = 'qrCodes',
  Score = 'scores',
  Search = 'searches',
  AssignmentGrade = 'assignmentGrades',
  CourseSectionGrade = 'courseSectionGrades',
  PublisherSummary = 'publisherSummary',
  SchoolSummary = 'schoolSummary',
  SignInEmail = 'signInEmails',
  Slide = 'slides',
  Summarization = 'summarizations',
  Content = 'contents',
  TaskCount = 'taskCounts',
  Task = 'tasks',
  Term = 'terms',
  TranscriptionJob = 'transcriptionJobs',
  TranscriptionAssessmentJob = 'transcriptionAssessmentJobs',
  Translation = 'translations',
  Transaction = 'transactions',

  TutorThread = 'tutorThreads',
  UserCode = 'userCodes',
  Refund = 'refunds',
  UnassignProductFromCourseSection = 'unassignProductFromCourseSections',

  UnassignProductToCourseSectionJob = 'unassignProductToCourseSectionJobs',
  UpdateEditionToProductJob = 'updateEditionToProductJobs',

  UnsavedPrompt = 'unsavedPrompts',
  UnsubmittedAnswer = 'unsubmittedAnswers',
  VideoConversionJob = 'videoConversionJobs',
  ThreadBulkActions = 'threadBulkActions',
  BulkImportIsbns = 'bulkImportIsbns',

  PromptJob = 'promptJobs',

  Videos = 'videos',
}

export const isValidItemType = (value: any): boolean => {
  return Object.values(ItemType).find((item: string) => item === value) !== undefined;
};
